import { ReactNode } from 'react'
import { useAppSelector } from 'lib/redux'
import ForbiddenPage from 'pages/403'

interface Props {
  children?: ReactNode
}

const PermissionCheck = ({ children }: Props): JSX.Element => {
  const havePermission = useAppSelector(
    ({ permission }) => permission.hasPermission
  )

  if (havePermission) {
    return <>{children}</>
  }

  return <ForbiddenPage />
}

export default PermissionCheck
